import axiosInstance from './axiosInstance';

/**
 * Reste disponible algébrique d'un encaissement + détail des imputations actives.
 * @param {string} encaissementTrackingId UUID
 * @returns {Promise<{encaissementTrackingId, numeroCheque, montantCheque, totalImpute, resteDisponible, imputations}>}
 */
export const getResteEncaissement = async (encaissementTrackingId) => {
    const res = await axiosInstance.get(
        `/v1/encaissements/${encaissementTrackingId}/reste-disponible`);
    return res.data?.data;
};

/**
 * Couverture financière complète d'un sinistre (encaissements, préfis, soldes, breakdown).
 * @param {string} sinistreTrackingId UUID
 * @returns {Promise<{sinistreTrackingId, totalEncaisseActif, totalPrefiActif, totalPaiementsActifs, soldeNet, regleAOk, regleBOk, regleCOk, message, encaissements, prefis}>}
 */
export const getCouvertureSinistre = async (sinistreTrackingId) => {
    const res = await axiosInstance.get(
        `/v1/sinistres/${sinistreTrackingId}/couverture`);
    return res.data?.data;
};

/**
 * Liste les paiements legacy (sans imputations explicites) d'un sinistre.
 * @param {string} sinistreTrackingId
 * @returns {Promise<Array<{paiementTrackingId, numeroPaiement, beneficiaire, montant, dateEmission, statut}>>}
 */
export const getLegacyPaiements = async (sinistreTrackingId) => {
    const res = await axiosInstance.get(
        `/v1/admin/reconciliation/sinistres/${sinistreTrackingId}/legacy-paiements`);
    return res.data?.data || [];
};

/**
 * Réconciliation manuelle de paiements legacy (admin/comptable uniquement).
 * @param {string} sinistreTrackingId
 * @param {Array<{paiementTrackingId: string, imputations: Array<{encaissementTrackingId: string, montant: number}>}>} paiementsImputations
 * @returns {Promise<number>} nombre d'imputations créées
 */
export const soumettreReconciliation = async (sinistreTrackingId, paiementsImputations) => {
    const res = await axiosInstance.post(
        `/v1/admin/reconciliation/sinistres/${sinistreTrackingId}`,
        { sinistreTrackingId, paiementsImputations });
    return res.data?.data;
};
